export const carrierLanesPageStateKey = 'carrier-lanes-page';

export interface CarrierLanesState {
	error: string | null;
	loading: boolean;
	currentPage: number;
	pageSize: number;
	filters: any[];
	sort: any[];
	lanesList: any[];
	total: number;
}

export const initialState: CarrierLanesState = {
	error: null,
	loading: true,
	currentPage: 0,
	pageSize: 25,
	filters: [],
	sort: [],
	lanesList: [],
	total: 0,
};
